<template>
	<div>
		<normalBar title="确认订单" :path="gobackPath"></normalBar>
		<div class="default-panel firm-panel">
			<div class="grey-bg-sec">
				<div class="address-sec" v-if="!isWxLogin&&!isSignSuccess" v-cloak @click="goAddressList(0)">
				<!-- h5游客 -->
					<span class="big-size">请新建收货地址</span>
					<span class="icon-arrow-right"  ></span>
				</div>
				<div class="address-sec" v-if="!isSignSuccess && isWxLogin"  v-cloak @click="goAddressList(2)">
				<!-- 微信但未绑定手机号 -->
					<span class="big-size">请新建收货地址</span>
					<span class="icon-arrow-right"  ></span>
				</div>
				
				<div class="address-sec" v-if=" isSignSuccess && addressCode == '03206' "  v-cloak  @click="goAddressList(3)">
				<!-- 已登录无地址 -->
					<span class="big-size">请新建收货地址</span>
					<span class="icon-arrow-right" ></span>
				</div>
				<div class="address-sec" v-if="isSignSuccess && addressCode == '03209'"  v-cloak   @click="goAddressList(1)">
					<span class="big-size">无符合条件的配送地址，点击修改</span>
					<span class="icon-arrow-right"></span>
				</div>
				<div class="address-sec" v-if="isSignSuccess && orderAddress.id"  v-cloak @click="goAddressList(1)">
					<div class="address-content">
						<p class="big-size">{{orderAddress.recipientName}}<span class="last">收</span></p>
						<p>{{orderAddress.address}}</p>
						<p>{{orderAddress.recipientMobile | filterPhone}}</p>
					</div>
					<span class="icon-arrow-right"></span>
				</div>
			</div>

			<div class="grey-bg-sec">
				<div class="extra-sec">
					<div class="text-list">
						<mt-cell title="配送日期" label="(限自营配送)" v-if="hasOwnDelivery">
							<span class="text" @click="openPicker">{{deliveryDate?deliveryDate:'未选择'}}</span>
							<span class="icon-arrow-right"></span>
						</mt-cell>
						<mt-cell title="配送时间" label="(限自营配送)" v-if="hasOwnDelivery">
							<span class="text" @click="openTimer">{{deliveryTime ? deliveryTime : '未选择'}}</span>
							<span class="icon-arrow-right"></span>
						</mt-cell>
						<mt-cell title="订单备注">
							<textarea v-model="orderMarks" class="input-marks orderMarks"  maxlength="60" placeholder="限定60字（请将购买需求在备注中详细说明）"/></textarea>
						</mt-cell>
					</div>	
				</div>
			</div>

			<div class="grey-bg-sec" v-for="(itemList,index) in preOrder" :key="index">
				<div class="gift-sec">
					<div class="gift-header">·<span class="title-tips">{{itemList.preOrderName}}</span>· ({{itemList.deliveryTypeDesc}})</div>
					<div class="gift-body">
						<router-link :to="{ path: '/productdetail/'+item.goodsChannelId, query: { url: router + '?url=' + gobackPath }}"  v-for="item in itemList.goodsList" :key="index">
						<div class="media">
							<div class="media-left">
								<img :src="item.thumb" alt="" v-if="!!item.thumb">
								<img src="../../assets/images/default-pro-small.png" alt="" v-else>
							</div>
							<div class="media-content">
								<p class="m-title">
									<span>{{item.goodsName}}</span>
									<span class="m-small">X{{item.goodsNum}}</span>
								</p>
								<span class="m-subTitle">{{item.skuPropertyValue}}</span>
								<div class="m-operate">
									<div class="m-operate-cont">
										<span class="price text-red">¥{{item.salePrice | filterPrice}}</span>
										<span class="text-grey" v-if="item.birthdayCardContent">
											生日牌：{{item.birthdayCardContent}}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div class="greetContent" v-if="item.greetingCardContent">
							<span class="title">祝福卡：</span><span class="content">{{item.greetingCardContent}}</span>
						</div>
						</router-link>
					</div>
				</div>
			</div>
		</div>
		
		<div class="firm-bottom-sec">
			<div class="firm-bottom-content">
				<div class="firm-bottom-left">
					<span>
						合计：<span class="text-red">¥{{ firmAmount | filterPrice}}</span>
					</span>
					<span class="text-grey">含运费</span>
				</div>
				<span class="checkout-btn" :class="{disabled: orderAddress.id ? '' : true}" @click="confirmOrder">
					提交订单
				</span>
			</div>
		</div>


		<mt-datetime-picker
		    ref="picker"
		    type="date"
		    v-model="pickerValue"
		    :visibleItemCount = 5
		    :startDate = "stDate"
		    year-format="{value} 年"
			month-format="{value} 月"
			date-format="{value} 日"
			@confirm="confirmDate"
		>
		</mt-datetime-picker>


		
		<mt-popup
		  	v-model="timerShow"
		  	position="bottom"
			class='deliverPick'
		  	>
			<mt-picker 
					:slots="slots" 
					:showToolbar= true
					:visibleItemCount =3
					@change="onValuesChange">
					<span class="mint-datetime-cancel" @click="timerShow = false">取消</span><span class="mint-datetime-confirm" @click="setDeliveryTime">确定</span>
				</mt-picker>
		</mt-popup>

	</div>
</template>


<script>
	import Vue from 'vue';
	import { Picker } from '@/js/mint-ui';
	import { Swipe, SwipeItem } from '@/js/mint-ui';
	import { Cell } from '@/js/mint-ui';
	import { DatetimePicker } from '@/js/mint-ui';
	import { MessageBox } from '@/js/mint-ui';
	import { Popup } from '@/js/mint-ui';
	import { Toast } from '@/js/mint-ui';

	Vue.component(Popup.name, Popup);
	Vue.component(Picker.name, Picker);
	Vue.component(DatetimePicker.name, DatetimePicker);
	Vue.component(Swipe.name, Swipe);
	Vue.component(SwipeItem.name, SwipeItem);

	

	import normalBar from '@/components/common/navbar/normalBar'
	
	import api from '@/api/api.js';

	import { mapState,mapGetters } from 'vuex'
	export default{
		data(){
			return {
				submitLoading: true,
				addressValid: false,//地址正确
				pickerValue: '',
				deliveryDate: '',//配送日期
				deliveryTime: '',//配送时间
				tempTimer:'',
				timerShow: false,
				orderMarks: '',
				slots: [
			        {
			          flex: 1,
			          values: [],
			          className: 'slot1',
			          textAlign: 'center',
			          showToolbar: true
			        }
			    ],
			    addressCode: null,//00000 正常， 03206 说明用户无收货地址 code 03209 说明没有匹配到当前区域的收货地址
			    stDate: new Date(),
			}
		},
		computed:{
	     	router(){
	        	return this.$route.path;
	      	},
			isSignSuccess(){
				return this.utils.isLogin();
			},
			...mapState({
				preOrder: state=>state.shopCart.firmOrder.preOrderInfos,
				shopCartFeeInfo: state=>state.shopCart.firmOrder.shopCartFeeInfo,
				orderAddress: state=>state.shopCart.orderAddress,
				firmAmount: state=>state.shopCart.firmTotalAmount,
				hasOwnDelivery: state=>state.shopCart.hasOwnDelivery,
			}),
		    gobackPath () {
			    if (this.$route.query['url'] === undefined) {
			      return '/shoppingCart'
          	}
				  return this.$route.query['url']
		    },
		    isWxLogin () {
				return this.utils.isWxLogin()
		    },

		},
		components: {
			normalBar
		},
		methods: {
			openPicker() {

        		this.$refs.picker.open();
      		},
      		openTimer(){
      			if(this.deliveryDate){
      				this.timerShow = true;
      			}else {
      				Toast('请选择配送日期')
      			}
      			
      		},
      		confirmDate(value){//选择配送日期
      			let self = this;

      			if(!self.orderAddress.id){
					Toast("请先选择地址");
					//return false; 测试注销
				}
				
      			let year = value.getFullYear() < 10 ? '0'+value.getFullYear() : value.getFullYear();
      			let month= (value.getMonth()+1) < 10 ? '0'+(value.getMonth()+1) : (value.getMonth()+1);
      			let days = value.getDate() < 10 ? '0' + value.getDate() : value.getDate();
      			this.deliveryDate =year+ '/'+month+'/'+days;

				let parma = {
					deliveryDate: year+ '-'+month+'-'+days,
					regionId: self.orderAddress.regionalismId
				}

				this.$store.dispatch('getDeliveryTimer',parma).then(function(res){
					console.log(res);
					var times = res.times || [];
		            var timeFormat = function(time){
		              time = time.split(':');
		              var hour = time[0].length > 1 ? time[0] : ('0' + time[0]);
		              var minute = time[1].length > 1 ? time[1] : ('0' + time[1]);
		              return hour + ':' + minute;
		            };
		            var new_time_range = self.deliveryTimeRange().filter(function(n){
		              return times.some(function(t){
		                var a = n.split('~');
		                return a[0] >= timeFormat(t.startTime) && a[1] <= timeFormat(t.endTime);
		              });
		            });

					var new_time_range = self.deliveryTimeRange().filter(function(n){
		              return times.some(function(t){
		                var a = n.split('~');
		                return a[0] >= timeFormat(t.startTime) && a[1] <= timeFormat(t.endTime);
		              });
		            });
					self.slots[0].values = new_time_range;
				})
      		},
      		deliveryTimeRange(){
      			/**
		        '00:00~01:00',
		        '00:30~01:30',
		        ...
		        '22:30~23:30',
		        '23:00~24:00',
		        '23:30~24:30'
		       */
		      	var r = [];
		      	var format = function(time){ return time < 10 ? '0' + time : time; };
		      	for(var i=0; i<24; i++){
		        	r.push(
			          format(i) + ':00~' + format(i+1) + ':00',
			          format(i) + ':30~' + format(i+1) + ':30'
		        	)
		      	}
		      	return r;
		    },
      		setDeliveryTime(){//设置配送时间
				this.deliveryTime = this.tempTimer;
				this.timerShow = false;
      		},
      		onValuesChange(picker, values) {
			    this.tempTimer = values[0];
			},
			msgBox(){
				let self = this;
				MessageBox.confirm('','',{
					title: '',
					message: '当前日期已暂停预约，请选择其他日期?',
					confirmButtonText: '选择日期'
				}).then(action => {
	 				self.openPicker();
				});
			},
			confirmOrder(){
				let self = this;
				const  { hasOwnDelivery , deliveryDate, deliveryTime} = this;
				if(!self.submitLoading) return false;
				if(self.recipientId == ''){
					Toast('请选择收货地址');
					// return false;

				}else if(hasOwnDelivery&&deliveryDate == ''){
					Toast('请选择配送日期');
					return false;

				}else if(hasOwnDelivery&&deliveryTime == ''){
					Toast('请选择配送时间');
					return false;
				}

				let formData = {
					deliveryTime: self.deliveryDate.replace(/\//g,'-')+' '+self.deliveryTime,//	配送时间	number	
					recipientAddress: self.orderAddress.address,//	收货地址	string	
					recipientId:   self.orderAddress.id,//	收货人id	number	
					recipientMobile: self.orderAddress.recipientMobile,//	收货人电话	string	
					regionalismId: self.orderAddress.regionalismId,//	区域id	number	
					remarks: self.orderMarks,//
					totalGoodsPrice: self.totalGoodsPrice,
					finalOrderPrice: self.finalOrderPrice,
					freight: self.freight
				};


				console.log('formData',formData);
				self.submitLoading = false;
				self.$store.dispatch('confirmOrder',formData).then(function(res){
					if (window.location.host == 'wap.blissmall.net') {
			            window.location.href = window.location.origin+'/wx/?#/payTypes/'+res.payNo
			        } else {
			            self.$router.push({
			              	path: '/payTypes/'+res.payNo
			       	 	})
         		 	}
				},function(res){
					Toast(res.msg || '提交失败');
					if(res.code == '01073'){
						self.getInit();
					}
				}).then(function(){
					self.submitLoading = true;
				})
			},
			goAddressList(type){
				const { hasOwnDelivery } = this;
				if(type == 0){
					this.$router.push({
						name: 'addressNoLoginAdd',
						query: {
							isFirmOrder: true,
							hasOwnDelivery: hasOwnDelivery ? 1: 2 //1是有自营配送订单 2是无

						}
					})
				}else if(type == 2){
				  console.log(this.$route.query.url)
					this.$router.push({ name: 'bindMobilePhone', query: { url: '/firmOrder?url=/productShoppingCart?isProCart=true' }})

				}else  if(type == 1){
					this.$router.push({
						name: 'addressList',
						query: {
							isOrderAddress: hasOwnDelivery ? true : false,
							url: '/firmOrder'
						}
					})
				}else if(type == 3){
					this.$router.push({
						path: '/addressEdit/add',
						query: {
							url: '/addressList?isOrderAddress=true&url=%2FfirmOrder'
						}
					})
				}
			},
			getInit(){
				let self = this;
				
				self.$nextTick(function(){
					self.$store.dispatch('getFirmOrder').then(()=>{
						const {hasOwnDelivery} =this;
						console.log('hasOwnDelivery',hasOwnDelivery);
						let params = self.$route.query;
						if(self.isSignSuccess){
							if(params.id ){
								self.$store.dispatch('setOrderAddress',params)
							}else {
								self.$store.dispatch('getFirmOrderAddress',{type: hasOwnDelivery ? 0 :1})
								.then(function(code){
									console.log('code:'+code);
									self.addressCode = code;
								})
							}
						}
					});
					
				});
			}
		},
		mounted(){
			this.getInit();
		}
	}


</script>

<style lang="scss">
	@import '../../assets/css/mixin';


	.firm-panel {

		.address-sec {
			margin-top: - 1px;
			padding: pxToRem(60px) pxToRem(50px)  pxToRem(60px)  pxToRem(65px);
			display: flex;
			justify-content: space-between;
			font-size: pxToRem(22px);
			background-color: #fff;
			align-items: center;
			border-top: 1px solid #D4B675;
			border-bottom: none;

			.big-size {
				font-size: pxToRem(28px);
				.last {
					margin-left: pxToRem(10px);
				}
			}


			.address-content {
				line-height: 1.2em;
				p {
					margin-top: pxToRem(10px);
				}
				.title {
					font-size: pxToRem(20px);
					color: #666;
				}
			}



		}

	}

	.extra-sec {
		background: #fff;
		.text-list {
			margin-top: 0;

			.text {
				color: #191919;
			}

			.mint-cell {
				padding-left: pxToRem(50px);
				min-height: pxToRem(120px);

				&:active {
					background: #fff;
				}

				&:last-of-type {
					.mint-cell-wrapper {
						align-items: flex-start;
						padding-top: pxToRem(40px);
						padding-bottom: pxToRem(40px);

						.orderMarks {
							padding: 0;
						}
					}
				}

				&:not(:last-of-type){
					.mint-cell-wrapper {
						border-bottom: 1px solid #bdbdbd;
					}
				}
				
				.mint-cell-wrapper {
					padding-right: pxToRem(50px);
					padding-left: pxToRem(15px);
					
					.is-link {
						font-size: pxToRem(11px);
					}

					.mint-cell-label {
						display: inline-block;
						margin-top: 0;
						vertical-align: middle;
						color: #999;
					}
				} 

				.mint-cell-text {
					color: #666;
				}
			}

			.icon-arrow-right {
				margin-left: pxToRem(20px);
			}
		}

		.input-marks {
			padding: pxToRem(5px) pxToRem(10px);
			width: pxToRem(440px);
			text-align: right;
			font-size: pxToRem(20px);
    		resize: none;
    		border: none;
			&::placeholder {
				color: #BDBDBD;
			}
		}
	}

	.gift-sec {
		background-color: #fff;
		.gift-header {
			text-align: center;
			line-height: pxToRem(66px);
			color: #030303;
			.title-tips {
				margin: 0 pxToRem(10px);
				color: #666;
			}
		}

		.media{
			padding: pxToRem(34px) pxToRem(54px) pxToRem(34px) pxToRem(66px);
			border-top: 1px solid #eeeeee;
			.m-operate {
				padding-right: 0;
			}
			.m-title {
				.m-small {
					color: #191919;
					position: absolute;
				    top: 0;
				    right: 0;
				}
			}
			.text-grey {
				color: #666666;
			}
			.m-subTitle {
				color: #999;
			}
		}

		.greetContent {
			padding: 0 pxToRem(54px) pxToRem(34px) pxToRem(66px);
			color: #666666;
			display: flex;

			.title {
				width: pxToRem(100px)
			}
			.content {
				flex: 1;

			}
		}
	}

	.firm-bottom-sec {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		font-size: $defaultSize;
		border-top: 1px solid #eee;
		background-color: #fff;

		.firm-bottom-content {
			display: flex;

			.firm-bottom-left {
				padding: 0 pxToRem(20px) 0 pxToRem(40px);
				flex: 1;
				display: inline-flex;
				align-items: center;
				justify-content: space-between;

				.text-gray {
					margin-left: pxToRem(20px);
				}

			}
			.checkout-btn {
				width: pxToRem(230px);
				height: pxToRem(115px);
				line-height: pxToRem(115px);
				text-align: center;
				color: #fff;
				font-size: pxToRem(32px);
				background-color: #D8331D;
				&.disabled {
					background-color: #CCCCCC;
				}
			}
		}
	}

	.mint-datetime-action {
		color: #544014;
		font-size: pxToRem(24px);
	}
	
	.deliverPick {
		width: 100%;
		
		
	}

	

</style>


// WEBPACK FOOTER //
// firmOrder.vue?62705306